import { NavCarouselItem } from 'app/components'
import { Layout, Users, Cog, Compass, MessageCircle, Pencil } from '@tamagui/lucide-icons'

export const groupNavLinks: NavCarouselItem[] = [
  {
    label: 'Groups Home',
    href: '/groups/feed',
    Icon: Layout,
  },
  {
    label: 'Your Groups',
    href: '/groups/your-groups',
    Icon: Users,
  },
  {
    label: 'Your Moderated Groups',
    href: '/groups/your-moderated-groups',
    Icon: Cog,
  },
  {
    label: 'Discover Groups',
    href: '/groups/discover',
    Icon: Compass,
  },
  {
    label: 'DMs',
    href: '/groups/chat',
    Icon: MessageCircle,
  },
  {
    label: 'Your Posts',
    href: '/groups/your-posts',
    Icon: Pencil,
  },
]
